import '../../styles/common.scss';
import { siteHeader } from '../components/header';
import { initCarouselSlider } from '../components/carousel';
import { initHomeSlider } from '../components/sliders';
import { initGallerySlider } from '../components/gallery';
import { initSlider } from '../components/slider';
import { initAccordion } from '../components/accordion';
import { initVacancy } from '../components/vacancy';
import { wijkenMap } from '../components/maps';
import { mapInfo } from '../components/infobox';
import { initPrice } from '../components/price';
import { initPopup } from '../components/popup';
 import { initUpload } from '../components/upload';

export function render() {
	siteHeader();
	initCarouselSlider();
	initGallerySlider();
	initHomeSlider();
    initSlider();
	initAccordion();
	initVacancy();
	wijkenMap();
	mapInfo();
	initPrice();
	initPopup();
	initUpload();
}
